import { CollaboratorsService } from './../../services/collaborators.service';
import { Collaborators } from './../../interfaces/collaborators';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {environment} from "../../../environments/environment";
@Component({
    selector: 'app-collaborator-add-edit',
    templateUrl: './collaborator-add-edit.component.html',
    styleUrls: ['./collaborator-add-edit.component.scss'],
    standalone: false
})
export class CollaboratorAddEditComponent implements OnInit {
	siteName = '';
	domaneUrl = '';
	imageUrl = '';
	collor = ''
	processing = false;
	collaboratorsUser: any;
	collaboratorsForm: any;
	constructor(private dialogRef: MatDialogRef<CollaboratorAddEditComponent>,
		private fb: UntypedFormBuilder,
		public CollaboratorsService: CollaboratorsService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public _snackBar: MatSnackBar) {
		this.collaboratorsForm = this.fb.group(this.addEditForm(data.collaborators));
			const host = window.location.hostname;
			if (host === environment.skyDomain) {
				this.siteName = 'Skystream';
				this.domaneUrl = 'https://app.skystreamevents.com';
				this.imageUrl = 'skystream_logo.png';
				this.collor = '#0f57c6';
			}
			else if (host === environment.tune2Domain || host === environment.tune2Domain2) {
				this.siteName = 'Tune2';
				this.domaneUrl = 'https://admin.tune2.app';
				this.imageUrl = 'tune2-logo.webp';
				this.collor = '#de072a';

			}
			else if (host === environment.igniteDomain) {
				this.siteName = 'IGNITE LIVE';
				this.domaneUrl = 'https://live.ignitefiringsystems.com';
				this.imageUrl = 'IGNITE_Live_Logo.png';
				this.collor = '#ce38f3';

			}
			else {
				this.siteName = 'Pyrocast';
				this.domaneUrl = 'https://app.pyrocast.com';
				this.imageUrl = 'logo-sm.png';
				this.collor = '#2cbcf4';

			}

	}
	addEditForm(data: any) {
		return {
			// admin_email: [data.admin_email ?? '', Validators.required],
			email: [data.email ?? '', Validators.required],
		};
	}

	ngOnInit(): void {	}

	save() {
		if (!this.processing && this.collaboratorsForm.valid) {
			const collaboratorsUser = this.collaboratorsForm.value as Collaborators;
			if (this.data.collaborators) {
				collaboratorsUser.id = this.data.collaborators.id;
			}
			collaboratorsUser.siteName = this.siteName;
			collaboratorsUser.domaneUrl = this.domaneUrl;
			collaboratorsUser.imageUrl = this.imageUrl;
			collaboratorsUser.collor = this.collor;
			this.processing = true;
			this.CollaboratorsService.storeOrEdit(collaboratorsUser)
				.subscribe((res: any) => {
					if (res.status) {
						this.processing = false;
						this.dialogRef.close(res.collaboratorsUser);
						this._snackBar.open('Collaborators User updated successfully.', 'Dismiss');
					}
				});
		}
	}

}
